<template>
  <CustomValidationObserver
    v-slot="{ handleSubmit }"
    tag="div"
    class="form-container"
  >
    <BForm class="mt-3" @submit.stop.prevent="handleSubmit(submit)">
      <ValidationProvider
        v-slot="validationState"
        name="コード"
        :rules="{ required: true, numeric: true, min: 4, max: 4 }"
        v-model="officeCode"
      >
        <TextFieldGroup
          v-model="officeCode"
          placeholder="0000"
          inputmode="numeric"
          :formatter="sliceString"
          class="input"
          :validation-state="validationState"
        />
      </ValidationProvider>
    </BForm>

    <AppButton
      v-if="workStatus === 'start'"
      variant="secondary"
      block
      class="mt-4"
      @click="handleSubmit(submit)"
    >
      仕事開始
    </AppButton>

    <AppButton
      v-if="workStatus === 'finish'"
      variant="secondary"
      block
      class="mt-4"
      @click="handleSubmit(submit)"
    >
      仕事終了
    </AppButton>
  </CustomValidationObserver>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";

@Component({
  components: {
    AppButton,
    TextFieldGroup
  }
})
export default class AttendanceCodeForm extends Vue {
  @Prop({ required: true })
  workStatus!: "start" | "finish";

  officeCode = "";

  sliceString(value: string) {
    return value.slice(0, 4);
  }

  submit() {
    this.$emit("submit", this.officeCode, "manual");
  }
}
</script>
<style lang="scss" scoped>
.input {
  transition: all 0.2s;

  :deep(.app-textfield) {
    padding-left: 12px;
    font-size: 24px;
    font-weight: 500;
    color: $white;
    letter-spacing: 4px;
    background-color: rgb(0 0 0 / 0%);
    background-image: none;
    border-radius: 16px;

    &::placeholder {
      color: rgba($white, 0.6);
    }

    &.is-valid,
    &.is-invalid {
      padding-left: 48px;
    }

    &.is-invalid {
      border-color: $primary-yellow;

      &:focus {
        box-shadow: 0 0 0 0.2rem rgba($primary-yellow, 25%);
      }
    }
  }

  .invalid-feedback {
    color: $primary-yellow;
  }
}
</style>
